import { gateway } from "../../../../gateway";

export const getQuotesOverview = async (token) => {
  try {
    const response = await gateway.get(
      `/quotes/analytics`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener overview de quotes", error);
    throw error;
  }
};
